<template>
    <div>
      <div
        id="backpackerMedicalModal"
        class="modal"
        tabindex="-1"
        aria-labelledby="backpackerMedicalModalLabel"
        aria-hidden="true"
      >

        <div class="modal-dialog modal-lg">
          <div class="modal-content p-4">
            <h2 class="text-center">Automatically covered pre-existing medical conditions</h2>
            <div>
          </div>
  
          <div class="my-5">
            <p>You do not need to call the medical screening helpline in respect of the following automatically covered medical conditions, as they are automatically covered at no additional premium provided you do not also have a pre-existing medical condition. If you have a pre-existing medical condition in addition to any of the following automatically covered pre-existing medical conditions, all conditions will be excluded from cover, unless they are disclosed to the medical screening helpline and additional cover is agreed in writing.</p>
        <ul>
          <li>Acne</li>
          <li>Eczema</li>
          <li>ADHD</li>
          <li>Allergic reaction (Anaphylaxis) provided you have not needed hospital treatment for this in the last 2 years.</li>
          <li>Allergic rhinitis</li>
          <li>Arthritis (you must be able to walk independently at home without using mobility aids).</li>
          <li>Asthma (the asthma be controlled by no more than 2 inhalers and no other medication).</li>
          <li>Blindness or partial sightedness.</li>
          <li>Carpal tunnel syndrome</li>
          <li>Cataracts</li>
          <li>Chicken pox - if completely resolved.</li>
          <li>Common cold or flu</li>
          <li>Cuts and abrasions that are not self inflicted and require no further treatment.</li>
          <li>Cystitis - provided there is no on-going treatment.</li>
          <li>Deafness</li>
          <li>Diabetes (which is controlled by diet or tablets only).</li>
          <li>Diarrhoea and vomiting - if completely resolved.</li>
          <li>Enlarged prostate - benign only.</li>
          <li>Essential tremor</li>
          <li>Glaucoma</li>
          <li>Gout</li>
          <li>Haemorrhoids</li>
          <li>Hay fever</li>
          <li>Ligament or tendon injury - provided you are not currently being treated.</li>
          <li>Macular degeneration</li>
          <li>Menopause</li>
          <li>Migraine - provided there are no on-going investigations.</li>
          <li>Nasal polyps</li>
          <li>PMT</li>
          <li>RSI</li>
          <li>Sinusitis - provided there is no on-going treatment.</li>
          <li>Skin or wound infections that have completely resolved with no current treatment.</li>
          <li>Tinnitus</li>
          <li>Underactive thyroid (Hypothyroidism)</li>
          <li>Urticarial</li>
          <li>Varicose veins in the legs.</li>
        </ul>
          </div>
          <div class="text-center">
             <button type="button" class="btn btn-outline-secondary mb-5" data-bs-dismiss="modal">Cancel</button>
          </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  export default {
    data() {
      return {
        modalShow:false,
      }
    },
    methods: {
      hideModal() {
        this.modalShow = false
      },
    }
  }
  </script>
  <style scoped>
  </style>